import React from "react";
import "../../styles/About.css";
import "../../styles/Staff.css";
import { Link } from "react-router-dom";

const Staff = () => {
  return (
    <div className="about-container">
      <div className="intro-para">
        <p>
          The Center for Noninvasive Mechanical Ventilation Alternatives and
          Pulmonary Rehabilitation was established in 1992. In consists of
          physicians and other health care professionals dedicated to the care
          of patients with neuromuscular weakness and respiratory impairment
          from any cause. [
          <Link
            to="/ourcenters"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            More about The Center.
          </Link>
          ]
        </p>
      </div>

      <div className="about-title">
        <h3>Center Physicians and Supporting Staff</h3>
      </div>

      {/* Introduction Section */}
      <div className="cent-container">
        <div className="about-introduction">
          <div className="centers-pro">
            <div className="centers-pro-item">
              <p>John R. Bach, M.D.</p>
              <ul>
                <li>
                  Medical Director, The Center for Noninvasive Mechanical
                  Ventilation Alternatives and Pulmonary Rehabilitation
                </li>
                <li>Professor of Physical Medicine and Rehabilitation</li>
                <li>
                  Vice Chairman, Department of Physical Medicine and
                  Rehabilitation
                </li>
                <li>Professor of Neurosciences, Department of Neurosciences</li>
                <li>
                  Associate Medical Director, Department of Physical Medicine
                  and Rehabilitation, University Hospital, Newark, N.J.
                </li>
              </ul>
            </div>
            <div className="centers-pro">
              <div className="centers-pro-item">
                <p>Jennifer Michaels, M.D.</p>
                <ul>
                  <li>Assistant Professor of Neurosciences</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>John Katz, M.D.</p>
                <ul>
                  <li>Associate Professor of Anesthesia</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Melissa Davidson, M.D.</p>
                <ul>
                  <li>Assistant Professor of Anesthesia</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Soly Barades, M.D.</p>
                <ul>
                  <li>Assistant Professor of Surgery</li>
                  <li>Chief of the Division of Otoparyngology</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Kenneth Swan, M.D.</p>
                <ul>
                  <li>Professor of General and Trauma Surgery</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Colin Bethyl, M.D.</p>
                <ul>
                  <li>Assistant Professor of Surgery</li>
                  <li>Assistant Professor of Pediatrics</li>
                  <li>Chief of Pediatric Surgery</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Sanjeev Sabharwal, M.D.</p>
                <ul>
                  <li>Assistant Professor of Orthopedics</li>
                  <li>Assistant Professor of Pediatrics</li>
                  <li>Chief of Pediatric Orthopedics</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Scott Baird, M.D.</p>
                <ul>
                  <li>Assistant Professor of Pediatrics</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Jose' Navado, M.D.</p>
                <ul>
                  <li>Assistant Professor of Pediatrics</li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Lou Saporito, B.S., R.R.T.</p>
                <ul>
                  <li>
                    Technical Director, Center for Noninvasive Mechanical
                    Ventilation Alternatives and Pulmonary Rehabilitation,
                    University Hospital, UMDNJ-NJMS, Newark, N.J.
                  </li>
                </ul>
              </div>

              <div className="centers-pro-item">
                <p>Ann Guylas, M.A., S.L.P.</p>
                <ul>
                  <li>
                    Department of Physical Medicine and Rehabilitation,
                    UMDNJ-New Jersey Medical School
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Staff;
